var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"grid"},_vm._l((_vm.src[_vm.shootType]),function(images,index){return _c('img',{key:index,staticClass:"image",attrs:{"src":images[0],"srcset":`${images[0]} 1x, ${images[1]} 2x`,"width":"400","height":"300"}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }